<nz-page-header *ngIf="pageHeader != undefined" [nzBackIcon]="pageHeader.backButton" (nzBack)="pageHeader.onButtonEmitter();">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item *ngFor="let pageCrumb of pageHeader.breadCrumbs">
      <a *ngIf="pageCrumb.link != ''" [routerLink]="[pageCrumb.link, pageCrumb.parameters]">{{pageCrumb.text}}</a>
      <span *ngIf="pageCrumb.link == ''">{{pageCrumb.text}}</span>
    </nz-breadcrumb-item>
  </nz-breadcrumb>
  <nz-page-header-title>
    <i *ngIf="pageHeader.icon != ''" nz-icon [nzType]="pageHeader.icon"></i>
    {{pageHeader.title}}
  </nz-page-header-title>
  <nz-page-header-extra *ngIf="pageHeader.buttons.length != 0">
    <button *ngFor="let button of pageHeader.buttons" nz-button [nzType]="button.type" (click)="button.onClick()">
      <i *ngIf="button.icon != ''" nz-icon [nzType]="button.icon" nzTheme="outline"></i>
      {{button.text}}
    </button>
  </nz-page-header-extra>
</nz-page-header>
